import { useTranslation } from "react-i18next";
import { useApp } from "@/context/AppContext";
import type { ThemeId } from "@/types";

const THEME_LABEL: Record<ThemeId, string> = {
  dark: "home.themes.dark",
  light: "home.themes.light",
};

export function ThemeSwitcher() {
  const { t } = useTranslation();
  const { config, theme, setTheme } = useApp();

  return (
    <div className="flex flex-col items-center gap-3">
      <p className="text-[11px] font-medium text-ink-30 uppercase tracking-[0.14em]">
        {t("home.chooseAppearance")}
      </p>
      <div className="flex items-center gap-2">
        {config.app.themes.map((option) => {
          const selected = theme === option.id;
          return (
            <button
              key={option.id}
              type="button"
              data-testid={`button-theme-${option.id}`}
              title={t(THEME_LABEL[option.id])}
              aria-pressed={selected}
              onClick={() => setTheme(option.id)}
              className={`flex items-center gap-2.5 px-4 py-2 rounded-full border transition-all duration-200 cursor-pointer ${
                selected
                  ? "border-ink-25 bg-ink-6 shadow-sm"
                  : "border-ink-8 hover:border-ink-20 hover:bg-ink-4"
              }`}
            >
              <span
                className="w-3 h-3 rounded-full shrink-0"
                style={{
                  background: option.swatch,
                  boxShadow: `0 0 0 1px ${option.swatchBorder}`,
                }}
              />
              <span
                className={`text-[11px] font-semibold tracking-wide transition-colors ${
                  selected ? "text-ink-80" : "text-ink-35"
                }`}
              >
                {t(THEME_LABEL[option.id])}
              </span>
              {selected ? (
                <svg
                  className="w-3 h-3 text-ink-60 shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="3"
                  aria-hidden="true"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}
